import axios from 'axios';

const driversService = {
    getDrivers,
    getDriverById,
    addDriver,
    editDriver,
    deleteDriver,
    editPermissions,
    getPermissionScope,
    getDriverBilling,
    updateDriverBilling,
    requestDriverPaymentMethod,
    getMyBillingCycles,
    getMyCurrentBillingCycle,
    getMyBillingAccountSessions,
    getMyBillingDecision,
}

async function getDrivers() {
    return await axios.get('/Drivers')
}

async function getDriverById(id) {
    return await axios.get(`/Drivers/${id}`)
}

async function addDriver(driverDetails) {
    return await axios.post('/Drivers', driverDetails)
}

async function editDriver(driverDetails) {
    return await axios.put(`/Drivers/${driverDetails.driverId}`, driverDetails)
}

async function deleteDriver(id) {
    return await axios.delete('/Drivers/DeleteDriver/'+id)
}

async function editPermissions(permissions) {
    return await axios.post(`/Drivers/EditPermissions`, permissions)
}

// spec 000227 — the chargers and business groups the current operator may grant permissions on. Served by the
// Tags controller because cards and drivers share one rule.
async function getPermissionScope() {
    return await axios.get('/Tags/PermissionScope')
}

// spec 000154 (S3.9) — thin proxies onto the Mobile BFF's new billing routes (contracts/rest-api.md #1).
async function getDriverBilling(driverId) {
    return await axios.get(`/Drivers/${driverId}/Billing`)
}

async function updateDriverBilling(driverId, request) {
    return await axios.put(`/Drivers/${driverId}/Billing`, request)
}

async function requestDriverPaymentMethod(driverId) {
    return await axios.post(`/Drivers/${driverId}/Billing/RequestPaymentMethod`)
}

// spec 000154 (S3.13) — thin proxies onto the Mobile BFF's driver self-service cycle routes
// (contracts/rest-api.md #3). `oper` is a GUID string; there is no "my billing everywhere" aggregate.
async function getMyBillingCycles(oper, take = 12) {
    return await axios.get(`/Drivers/Me/Billing/Cycles`, { params: { oper, take } })
}

async function getMyCurrentBillingCycle(oper) {
    return await axios.get(`/Drivers/Me/Billing/Cycles/Current`, { params: { oper } })
}

// spec 000154 (S4.1) - the caller's own billing route on one charge point, resolved by the same
// service the start path uses. No driver id crosses the wire: the caller is their JWT.
async function getMyBillingDecision(chargePointId) {
    return await axios.get(`/Drivers/Me/Billing/Decision`, { params: { chargePointId } })
}

async function getMyBillingAccountSessions(accountId) {
    return await axios.get(`/Drivers/Me/Billing/Accounts/${accountId}/Sessions`)
}

export default driversService;